import {API} from '../../Services';
import moment from "moment-jalaali";


async function RewardsData(merchantId){
    let token =  localStorage.getItem('token');
    return API.get(`/merchants/${merchantId}/rewards`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}



async function UserCouponData(is_consumed=false){
    let mallId = localStorage.getItem("mallId")
    let token =  localStorage.getItem('token');
    return API.get(`/malls/${mallId}/user-coupons?`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params:{
            is_consumed:is_consumed
        }
    });
}

async function UserCouponDataPage(next,is_consumed=false){
    console.log("Next : ",next)
    let path = next.split("malls");
    let token =  localStorage.getItem('token');
    return API.get(`/malls${path[1]}`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params:{
            is_consumed:is_consumed
        }
    });
}


async function MallRewardsData(is_consumed=false){
    let mallId = localStorage.getItem("mallId")
    let token =  localStorage.getItem('token');
    return API.get(`/malls/${mallId}/user_rewards?`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params:{
            is_consumed:is_consumed
        }
    });
}

async function MallRewardsDataPage(next,is_consumed=false){
    console.log("Next : ",next)
    let path = next.split("malls");
    let token =  localStorage.getItem('token');
    return API.get(`/malls${path[1]}`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params:{
            is_consumed:is_consumed
        }
    });
}

async function MallCreditCard(){
    let mallId = localStorage.getItem("mallId")
    let token =  localStorage.getItem('token');
    return API.get(`/users/malls/${mallId}/card-points`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}



async function FestivalsData(merchantId){
    let token =  localStorage.getItem('token');
    return API.get(`/merchants/${merchantId}/campaigns`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function StoreData(merchantId){
    let token =  localStorage.getItem('token');
    return API.get(`/merchants/public/${merchantId}`
        );
}

async function LastInvoiceData(merchantId){
    let token =  localStorage.getItem('token');
    return API.get(`/payments/invoices`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params: {merchant__uid:merchantId}
    });
}

const ConvertToJalali = (date) =>{
    return  moment.utc(date.split('+')[0]).format('jYYYY/jMM/jDD');
}

async function FactorData(factorId){
    let token =  localStorage.getItem('token');
    return API.get(`/payments/invoices/${factorId}`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function OrderData(OrderId){
    let token =  localStorage.getItem('token');
    return API.get(`/orders/${OrderId}/`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function CheckinMall(mallId){
    let token =  localStorage.getItem('token');

    return API.post(`/users/check-ins`,{uid:mallId},{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function CheckinMallWithToken(mallId,token){
    return API.post(`/users/check-ins`,{uid:mallId},{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function GuestBasketSyncApi(obj){
    console.log("guest Basket Sync ...")
    let token =  localStorage.getItem('token');
    return API.post(`shop/cart/bulk-products`,obj,{headers: { 'Authorization':  `Bearer ${token}`}});
}


export {GuestBasketSyncApi,CheckinMallWithToken,CheckinMall,UserCouponDataPage,UserCouponData,MallCreditCard,RewardsData,OrderData,MallRewardsDataPage, MallRewardsData,FestivalsData,ConvertToJalali,LastInvoiceData,FactorData,StoreData};
